import VoltError from 'VoltError'

/**
 * Mapping Error Table from the Backend
 * Key : name of the error code to be catch by generic fetch
 */

export const ERROR_BACKEND_MAPPING = {
    /***
     * Ufinity SSO
     */
    invalid_grant: (error = '') => {
        switch (error) {
            case '1010':
                return VoltError.codes.USER_ACCOUNT_LOCKED
            case '1000':
                return VoltError.codes.LOGIN_INVALID_CREDENTIALS
            default:
                return VoltError.codes.INVALID_GRANT
        }
    },
    too_many_request: () => VoltError.codes.AUTH_OAUTH_SLOW_DOWN_POLLING,
    request_timeout: () => VoltError.codes.REQUEST_TIMEOUT,
    'incorrect parameters': () => VoltError.codes.INVALID_API_ARGUMENT,
    'missing parameters': () => VoltError.codes.INVALID_API_ARGUMENT,
    'error contacting esps': () => VoltError.codes.EXTERNAL_BSS_CANNOT_BE_REACHED,
    'locked hub id account': () => VoltError.codes.USER_ACCOUNT_LOCKED,
    /***
     * Ufinity OTT Gateway
     */
    internal_server_error: () => VoltError.codes.HTTP_500_INTERNAL_SERVER_ERROR,
    // Error 1: Invalid JWT claims - iat
    // Error 2: No JWT token found in request headers
    unauthorized: (error = '', description) => {
        switch (description) {
            case 'Invalid JWT claims - iat':
                return VoltError.codes.UNAUTHORIZED_DUE_TO_SYSTEM_CLOCK_UNSYNCHRONIZED
            default:
                return VoltError.codes.AUTH_UNAUTHORIZED_USER
        }
    },
    // PurchaseSvodByBillReqDto was not found for parameters {productId=ADD_ON}
    not_found: () => VoltError.codes.PURCHASE_FAILED_DUE_INVALID_PARAMETERS,
    // "status":"BAD_REQUEST" / "message":"Validation error" / productType is mandatory / billRemark is mandatory
    bad_request: () => VoltError.codes.HTTP_400_BAD_REQUEST,
    // A0001 - Already entitled
    A0001: () => VoltError.codes.PURCHASE_FAILED_DUE_EXISTING_ENTITLEMENT,
    // Error Message from Nagra: {\"errorCode\":4402,\"message\":\"Account not found\",\"code\":404}
    N4402: () => VoltError.codes.ACCOUNT_NOT_FOUND,
    // [S8010] “ESPS - Billing account in dunning Error Code: 8030”
    S8030: () => VoltError.codes.PURCHASE_FAILED_DUE_ACCOUNT_CONFIGURATION,
    // [S8010] “ESPS - No data found in ESPS Error Code: 8010”
    S8010: () => VoltError.codes.PURCHASE_FAILED_DUE_INVALID_OFFER,
    // Oracle Exception Error.Unlikely to happen unless one of the systems is down.
    S9000: () => VoltError.codes.PURCHASE_FAILED_DUE_INVALID_OFFER, /// -
    // Account not found in Billing system.
    S9005: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_ACCOUNT_NOT_FOUND,
    // Account not active in Billing system.
    S9010: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_ACCOUNT_NOT_ACTIVE,
    // Account not eligible. Is not residential or employee category.
    S9015: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_ACCOUNT_NOT_ELIGIBLE,
    // Account in collection/Dunning
    S9020: () => VoltError.codes.PURCHASE_FAILED_DUE_ACCOUNT_CONFIGURATION,
    // Other reasons. Unlikely to happen.
    S9025: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_UNEXPECTED_ERROR,
    // Customer Has been BlackListed.
    S9030: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_ACCOUNT_BLACKLISTED,
    // Requested account is one of the excluded accounts to buy thru instant buy.
    S9040: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_ACCOUNT_NOT_ELIGIBLE,
    // Unexpected exception
    S9050: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_UNEXPECTED_ERROR,
    // Subscription is unsuccessful as you are currently enjoying discounts on your TV subscription. Please select another purchase option.
    S9060: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_DISCOUNT_CONFLICT,
    // You have an existing Sports Group contract. To sign up for Free EURO with Sports Group, please call 1633.
    S9070: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_EXISTING_CONTRACT,
    // Service has not been configured for Impulse Purchase.
    S9100: () =>
        VoltError.codes.PURCHASE_FAILED_BECAUSE_PRODUCT_NOT_CONFIGURED_FOR_IMPULSE_PURCHASE,
    // Channel already exists. Unlikely to happen.
    S9110: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_CONTENT_CONFLICT,
    // Channel does not exist.
    S9120: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_MISSING_ASSET,
    // TV primary service not found in customer assets.
    S9130: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_MISSING_ASSET,
    // Unable to retrieve service id.
    S9131: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_CONTENT_CONFLICT,
    // Channel is not configured for Impulse Purchase.
    S9140: () =>
        VoltError.codes.PURCHASE_FAILED_BECAUSE_PRODUCT_NOT_CONFIGURED_FOR_IMPULSE_PURCHASE,
    // Channel is not configured for Impulse Purchase.
    S9141: () =>
        VoltError.codes.PURCHASE_FAILED_BECAUSE_PRODUCT_NOT_CONFIGURED_FOR_IMPULSE_PURCHASE,
    // Channel is not configured for Impulse Purchase.
    S9142: () =>
        VoltError.codes.PURCHASE_FAILED_BECAUSE_PRODUCT_NOT_CONFIGURED_FOR_IMPULSE_PURCHASE,
    // Channel is not configured for Impulse Purchase.
    S9143: () =>
        VoltError.codes.PURCHASE_FAILED_BECAUSE_PRODUCT_NOT_CONFIGURED_FOR_IMPULSE_PURCHASE,
    // Not Allowed for Shinny pack Customer to purchase any shinny channel or bundle
    S9144: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_NOT_ALLOWED,
    // Not Allowed for Shinny pack Customer trying to purchase non shinny channel or bundle
    S9145: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_NOT_ALLOWED,
    // TVA channel is not configured for Impulse Purchase.
    S9146: () =>
        VoltError.codes.PURCHASE_FAILED_BECAUSE_PRODUCT_NOT_CONFIGURED_FOR_IMPULSE_PURCHASE,
    // Unable to update requested primary service to transaction
    S9150: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // Unable to invoke EAI web service for customer validation
    S9160: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // No transaction exists.
    S9200: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // Transaction timeout.
    S9210: () => VoltError.codes.PURCHASE_FAILED_DUE_SERVER_TIMEOUT,
    // STB Not Found.
    S9220: () => VoltError.codes.PURCHASE_FAILED_DUE_DEVICE_NOT_FOUND,
    // FAPI Internal Error
    S9221: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_UNEXPECTED_ERROR,
    // FAPI Internal Error
    S9222: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_UNEXPECTED_ERROR,
    // Provisioning Error.
    S9300: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // Input from BIEConexon is Invalid.
    S9400: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_INSTANT_BUY_SYSTEM_ERROR,
    // New channel is mutually exclusive with currently subscribed channels.
    S9500: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_CONTENT_CONFLICT,
    // Unexpected exception
    S9600: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_UNEXPECTED_ERROR,
    // ESPS sync is in progress
    S9610: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // ESPS sync is not complete
    S9611: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // Unexpected exception
    S9700: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_UNEXPECTED_ERROR,
    // Unexpected exception
    S9800: () => VoltError.codes.PURCHASE_FAILED_DUE_TO_UNEXPECTED_ERROR,
    // Create order fail.
    S9900: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // TVPlan not retrieved from ESPS
    S9147: () => VoltError.codes.PURCHASE_FAILED_DUE_BACKEND_CONFIG,
    // Not Allowed for Variety Pass customers to purchase any Bento channel or bundle
    S9080: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_NOT_ALLOWED,
    // Function is disabled
    S9450: () => VoltError.codes.PURCHASE_FAILED_BECAUSE_DISABLED_BY_SERVER,
}
